import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const LoginServices = {
  login: (data: { identifier: string; password: string; captcha_token?: string }) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}auth/login`, data);
  },
  refreshSession: (data: { refreshToken: string }) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}auth/refresh`, data);
  },
  /**
   * Idempotente en el backend: responde 200 aunque el identifier no exista
   * (para no permitir enumerar usuarios).
   */
  forgotPassword: (data: { identifier: string }) => {
    return HTTP.post<{ ok: true }, { ok: true }>(`${API_ENDPOINT.CORE}auth/forgot-password`, data);
  },
  /** Consume el token del correo. Single-use; revoca todas las sesiones del user. */
  resetPassword: (data: { token: string; newPassword: string }) => {
    return HTTP.post<{ ok: true }, { ok: true }>(`${API_ENDPOINT.CORE}auth/reset-password`, data);
  }
};
